import { render, staticRenderFns } from "./Browse-Folder-Breadcrumb.vue?vue&type=template&id=6f0c1be7&"
import script from "./Browse-Folder-Breadcrumb.vue?vue&type=script&lang=js&"
export * from "./Browse-Folder-Breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./Browse-Folder-Breadcrumb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports